import React, { useEffect, useState, useRef, useCallback } from 'react';
import './Layout.css';
import './Sidebar.css';
import './App.css';
import { useNavigate } from 'react-router-dom';

function CryptoCard({ crypto, onClick, currency, conversionRate }) {
  let converted = null;
  if (
    currency &&
    currency.toUpperCase() !== 'USD' &&
    crypto.currentPrice !== undefined &&
    crypto.currentPrice !== null &&
    conversionRate
  ) {
    const price = crypto.currentPrice * conversionRate;
    converted = `≈ ${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })} ${currency.toUpperCase()}`;
  }
  return (
    <div className="crypto-card" onClick={() => onClick(crypto.id)}>
      <img src={crypto.imgUrl} alt={crypto.name} className="crypto-img" />
      <div className="crypto-info">
        <div className="crypto-code">{crypto.code}</div>
        <div className="crypto-name">{crypto.name}</div>
        <div className="crypto-price">
          {crypto.currentPrice !== undefined && crypto.currentPrice !== null
            ? `$${crypto.currentPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })}`
            : <span style={{ color: '#aaa' }}>Prix inconnu</span>}
          {converted && (
            <div style={{ fontSize: 14, color: '#888', marginTop: 2 }}>{converted}</div>
          )}
        </div>
      </div>
    </div>
  );
}

const PAGE_SIZE = 20;

export default function CryptoList() {
  const [cryptos, setCryptos] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [currencies, setCurrencies] = useState([]);
  const [currency, setCurrency] = useState('');
  const loader = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/cryptos')
      .then(res => res.json())
      .then(data => {
        let arr = [];
        if (Array.isArray(data.content)) arr = data.content;
        else if (Array.isArray(data)) arr = data;
        setCryptos(arr);
        setFiltered(arr);
        setHasMore(arr.length > PAGE_SIZE);
      });
    fetch('/api/currencies')
      .then(res => res.json())
      .then(data => setCurrencies(data));
    const cookie = document.cookie.match(/currency=([^;]+)/);
    setCurrency(cookie ? cookie[1] : '');
  }, []);

  useEffect(() => {
    const s = search.toLowerCase();
    const f = cryptos.filter(c => {
      const match = (c.name && c.name.toLowerCase().includes(s)) ||
        (c.code && c.code.toLowerCase().includes(s)) ||
        (c.symbol && c.symbol.toLowerCase().includes(s));
      if (!match) return false;
      if (!category) return true;
      const cap = c.marketCap ?? c.marketcap;
      if (category === 'NANO_CAP' && cap < 10000000) return true;
      if (category === 'MICRO_CAP' && cap >= 10000000 && cap < 100000000) return true;
      if (category === 'SMALL_CAP' && cap >= 100000000 && cap < 1000000000) return true;
      if (category === 'MID_CAP' && cap >= 1000000000 && cap < 10000000000) return true;
      if (category === 'LARGE_CAP' && cap >= 10000000000) return true;
      return false;
    });
    setFiltered(f);
    setPage(1);
    setHasMore(f.length > PAGE_SIZE);
  }, [search, cryptos, category]);

  const displayed = filtered.slice(0, page * PAGE_SIZE);

  const handleScroll = useCallback(() => {
    if (!hasMore) return;
    if (loader.current) {
      const rect = loader.current.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        setPage(p => {
          const next = p + 1;
          setHasMore(filtered.length > next * PAGE_SIZE);
          return next;
        });
      }
    }
  }, [hasMore, filtered.length]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  let conversionRate = null;
  if (currency && currency.toUpperCase() !== 'USD' && currencies.length > 0) {
    const cur = currencies.find(c => c.code === currency.toUpperCase());
    if (cur && cur.conversionRate) {
      conversionRate = cur.conversionRate;
    }
  }

  return (
    <div className="crypto-list-page">
      <h2>Cryptos</h2>
      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <input
          type="text"
          placeholder="Search by code or name..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="crypto-search"
        />
        <select value={category} onChange={e => setCategory(e.target.value)} style={{ padding: 8 }}>
          <option value="">Toutes catégories</option>
          <option value="NANO_CAP">Nano Cap</option>
          <option value="MICRO_CAP">Micro Cap</option>
          <option value="SMALL_CAP">Small Cap</option>
          <option value="MID_CAP">Mid Cap</option>
          <option value="LARGE_CAP">Large Cap</option>
        </select>
      </div>
      <div className="crypto-grid">
        {displayed.map(crypto => (
          <CryptoCard
            key={crypto.id}
            crypto={crypto}
            onClick={id => navigate(`/cryptos/${id}`)}
            currency={currency}
            conversionRate={conversionRate}
          />
        ))}
      </div>
      {hasMore && <div ref={loader} style={{ height: 40 }} />}
      {!hasMore && displayed.length === 0 && <div>No cryptos found.</div>}
    </div>
  );
}
